import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { MEDIA_IMAGE_API } from "./apiRoutes";

const mutateAddNewsMediaImage = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${MEDIA_IMAGE_API}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const useAddNewsMediaImageMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddNewsMediaImage,
    ...queryParams,
  });

export default useAddNewsMediaImageMutation;
